<template>
  <div class="advance-download">
    <vuestic-widget>
      <el-form :inline="true"
               ref="form"
               :model="advanceForm"
               @submit="submit">
        <el-form-item :label="$t('t.app') + '：'"
                      label-width="37px">
          <el-select v-model="advanceForm.app_id"
                     :placeholder="$t('common.selectPlaceholder')">
            <el-option :label="$t('basic.select.all')"
                       value=""
                       selected />
            <el-option v-for="item in appList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('t.method') + '：'"
                      label-width="58px">
          <el-select v-model="advanceForm.method"
                     :placeholder="$t('common.selectPlaceholder')">
            <el-option :label="$t('basic.select.all')"
                       value=""
                       selected />
            <el-option v-for="(item,index) in methodList"
                       :key="index"
                       :label="item"
                       :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('report.timeZone') + '：'"
                      label-width="76px">
          <el-select v-model="advanceForm.zone_id"
                     :placeholder="$t('ticket.select')">
            <!-- <el-option value="Time Zone">Time Zone</el-option> -->
            <el-option value="America/Sao_Paulo">America/Sao_Paulo</el-option>
            <el-option value="Etc/GMT">Etc/GMT</el-option>
            <el-option value="Asia/Shanghai">Asia/Shanghai</el-option>
            <el-option value="America/Mexico_City">America/Mexico_City</el-option>
            <el-option value="America/Bogota">America/Bogota</el-option>
            <el-option value="America/Santiago">America/Santiago</el-option>
            <el-option value="America/Lima">America/Lima</el-option>
            <el-option value="America/Panama">America/Panama</el-option>
            <el-option value="America/Costa_Rica">America/Costa_Rica</el-option>
            <el-option value="America/Guayaquil">America/Guayaquil</el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('t.dateRange') + '：'"
                      label-width="81px">
          <el-date-picker v-model="advanceForm.time"
                          type="daterange"
                          unlink-panels
                          range-separator="-"
                          :start-placeholder="$t('report.startDate')"
                          :end-placeholder="$t('report.endDate')"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('t.fileType') + '：'"
                      label-width="76px">
          <el-select v-model="advanceForm.file_type">
            <el-option
              v-for="(mvalue, name, index) in fileTypeOptions"
              :key="index"
              :label="name"
              :value="mvalue"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-button class="btn btn-primary btn-micro"
                   @click="download">{{ $t("menu.download") }}</el-button>
      </el-form>

    </vuestic-widget>
    <div class="advance-table">
      <el-button class="btn btn-info btn-micro advance-refresh"
                 @click="refresh()">
        {{ "t.refresh" | translate }}
      </el-button>
      <el-table :data="tableData"
                @row-click="handleRowClick"
                ref="advanceTable"
                :empty-text="$t('t.noDataNoOrder')">
        <el-table-column prop="date"
                         :label="$t('report.showDetails')"
                         type="expand"
                         width="110">
          <template slot-scope="props">
            <el-form label-position="left"
                     inline
                     class="details-expand">
              <div class="form-child">
                <el-form-item :label="$t('appName') + '：'">
                  <span>{{ JSON.parse(props.row.conditions).app_name || "ALL"}}</span>
                </el-form-item>
                <el-form-item :label="$t('t.method') + '：'">
                  <span>{{ JSON.parse(props.row.conditions).method || "ALL"}}</span>
                </el-form-item>
              </div>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="create_time"
                         :label="$t('tables.listing.referenceDateTime')"
                         min-width="90px">
        </el-table-column>
        <el-table-column prop="start_time"
                         :label="$t('report.start')"
                         min-width="90px"> </el-table-column>
        <el-table-column prop="end_time"
                         :label="$t('report.end')"
                         min-width="90px"> </el-table-column>
        <el-table-column prop=""
                         :label="$t('report.result')">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 2">{{ formatDownloadResult(scope.row.result) }}</span>
            <span v-else-if="scope.row.status == 1">{{ $t("report.fail") }}</span>
            <span v-else>{{ $t("report.processing") }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="update_time"
                         :label="$t('tables.listing.updateTime')"
                         min-width="90px"> </el-table-column>
        <el-table-column prop=""
                         :label="$t('tables.apping.status')">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 2">
              <DownloadFileButton
                :download-log-id="scope.row.id"
                @click.native.stop
              />
              <DownloadPasswordButton
                :download-log-id="scope.row.id"
                @click.native.stop
              />
            </span>
            <span v-else-if="scope.row.status == 1">{{ $t("report.fail") }}</span>
            <span v-else>{{ $t("report.processing") }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-sizes="[10, 25, 50, 100]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { request, isDefine } from "@/utils/utils";
import { formatDownloadResult as translateDownloadResult } from "@/utils/downloadResult.js";
import DownloadFileButton from "@/package/DownloadFileButton.vue";
import DownloadPasswordButton from "@/package/DownloadPasswordButton.vue";
const moment = require("moment-timezone");
export default {
  components: {
    DownloadFileButton,
    DownloadPasswordButton,
  },
  data() {
    return {
      advanceForm: {
        app_id: "",
        method: "",
        zone_id: "",
        time: [],
        file_type: "xlsx",
      },
      appList: null,
      methodList: null,
      params: {
        app_id: "",
        method: "",
        merchant_no: "",
      },
      query: {
        start: "",
        end: "",
      },
      dataList: [],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      fileTypeOptions: {
        "XLSX": "xlsx",
        "CSV": "csv"
      },
    };
  },
  created() {
    this.advanceForm.time.push(
      moment().subtract(31, "days").format("YYYY-MM-DD 00:00:00")
    );
    this.advanceForm.time.push(moment().format("YYYY-MM-DD 23:59:59"));
    this.advanceForm.zone_id = "Etc/GMT";
  },
  mounted() {
    // 获取下拉数据
    this.getDropdownData();
    // 调用refresh
    this.refresh(1);
  },
  watch: {
    "advanceForm.zone_id": {
      handler: function (val) {
        this.query.start = moment
          .tz(
            moment.tz(this.advanceForm.time[0], this.advanceForm.zone_id),
            "UTC"
          )
          .format("YYYY-MM-DD HH:mm:ss");
        this.query.end = moment
          .tz(
            moment.tz(this.advanceForm.time[1], this.advanceForm.zone_id),
            "UTC"
          )
          .format("YYYY-MM-DD HH:mm:ss");
      },
    },
    "advanceForm.time": {
      handler: function (val) {
        if (!val) return;
        this.query.start = moment
          .tz(moment.tz(val[0], this.advanceForm.zone_id), "UTC")
          .format("YYYY-MM-DD HH:mm:ss");
        this.query.end = moment
          .tz(moment.tz(val[1], this.advanceForm.zone_id), "UTC")
          .format("YYYY-MM-DD HH:mm:ss");
      },
    },
  },
  methods: {
    formatDownloadResult(result) {
      return translateDownloadResult(this, result)
    },
    getDropdownData() {
      let token = localStorage.getItem("Authorization");
      let uid = localStorage.getItem("uid");
      let url = "api/dashboard/basic/getDropdown?access_token=" + token;
      request({
        method: "post",
        url,
        "": {},
      }).then((res) => {
        // res是返回结果
        this.appList = res.data.apps;
        this.methodList = res.data.method;
      });
    },
    download() {
      let token = localStorage.getItem("Authorization");
      let uid = localStorage.getItem("uid");
      let url = `/api/dashboard/payments/download?access_token=${token}&search_key=&zone_id=${this.advanceForm.zone_id}&start=${this.query.start}&end=${this.query.end}&file_type=${this.advanceForm.file_type}`;
      this.params.app_id = this.advanceForm.app_id;
      this.params.method = this.advanceForm.method;
      request({
        method: "post",
        url,
        data: JSON.stringify(this.params),
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => {
        // res是返回结果
        if (res.data.code == "10000") {
          this.$message({
            message: `${res.data.msg}`,
            type: "success",
          });
        } else {
          this.$message.error(`${res.data.msg}`);
        }
      });
    },
    refresh(type) {
      let token = localStorage.getItem("Authorization");
      let url = `/api/dashboard/payments/download-list?access_token=${token}`;
      request({
        method: "post",
        url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }).then((res) => {
        // res是返回结果
        if (res.data.code == "10000") {
          if (!isDefine(type)) {
            this.$message({
              message: `${res.data.msg}`,
              type: "success",
            });
          }
          this.currentPage = 1;
          this.dataList = res.data.data;
          this.total = res.data.data.length;
          this.tableData = this.currentChangePage(
            this.pageSize,
            this.currentPage
          );
        } else {
          this.$message.error(`${res.data.msg}`);
        }
      });
    },
    // change pageSize
    handleSizeChange(val) {
      this.pageSize = val;
      this.tableData = this.currentChangePage(this.pageSize, this.currentPage);
    },
    // change page
    handleCurrentChange(val) {
      this.currentPage = val;
      this.tableData = this.currentChangePage(this.pageSize, this.currentPage);
    },
    // pagination
    currentChangePage(size, current) {
      const tablePush = [];
      this.dataList.forEach((item, index) => {
        if (size * (current - 1) <= index && index <= size * current - 1) {
          tablePush.push(item);
        }
      });
      return tablePush;
    },
    // click row
    handleRowClick(row) {
      this.$refs.advanceTable.toggleRowExpansion(row);
    },
    submit() {
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.advance-download {
  .el-form--inline {
    /deep/ .el-form-item__label {
      padding: 0 !important;
      white-space: nowrap;
    }
  }
  .btn-micro {
    padding: 0.625rem 1.8rem;
    font-size: 85%;
    line-height: 1.25;
    border-radius: 1.875rem;
  }
  .advance-table {
    background-color: #ffffff;
    .advance-refresh {
      margin: 1rem;
      float: right;
    }
    .table-download {
      color: #4ab2e3;
    }
    /deep/ .el-table__header-wrapper {
      tr {
        background-color: #f3f2f7;
        th {
          background-color: #f3f2f7;
        }
      }
    }
    /deep/ .el-table__body-wrapper {
      tr {
        background-color: #fafafc;
        th {
          background-color: #fafafc;
        }
        td.el-table__expanded-cell {
          background-color: #fafafc;
        }
      }
    }
    .details-expand {
      padding: 0 20px;
      background-color: #ffffff;
    }
    .form-child {
      display: flex;
      justify-content: space-between;
      .el-form-item {
        width: 50%;
        margin-bottom: 0;
      }
    }
  }
  .el-pagination {
    text-align: center;
    margin-top: 20px;
    padding-bottom: 30px;
    margin-bottom: 30px;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4ae387;
  }
}
</style>
